// Copyright Square, Inc.
import { CUSTOMER_DATA_FRAMEWORK } from "../CustomerDataFramework.js";
/**
 * @see GrowToolsManageEnterEvent
 */
export var GrowToolsManageEnter = function (_a) {
    var origin = _a.origin, type = _a.type;
    return ({
        name: "GrowTools Manage Enter",
        parameters: {
            cdf_entity: "GrowTools",
            cdf_action: "Manage",
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GrowToolsManageExitEvent
 */
export var GrowToolsManageExit = function (_a) {
    var origin = _a.origin, type = _a.type;
    return ({
        name: "GrowTools Manage Exit",
        parameters: {
            cdf_entity: "GrowTools",
            cdf_action: "Manage",
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GrowToolsManageChangeTargetEvent
 */
export var GrowToolsManageChangeTarget = function (_a) {
    var origin = _a.origin, type = _a.type;
    return ({
        name: "GrowTools Manage ChangeTarget",
        parameters: {
            cdf_entity: "GrowTools",
            cdf_action: "Manage",
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GrowToolsManageShowMoreEvent
 */
export var GrowToolsManageShowMore = function (_a) {
    var origin = _a.origin, type = _a.type;
    return ({
        name: "GrowTools Manage ShowMore",
        parameters: {
            cdf_entity: "GrowTools",
            cdf_action: "Manage",
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GrowToolsManageActivityItemEvent
 */
export var GrowToolsManageActivityItem = function (_a) {
    var origin = _a.origin, type = _a.type;
    return ({
        name: "GrowTools Manage ActivityItem",
        parameters: {
            cdf_entity: "GrowTools",
            cdf_action: "Manage",
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GrowToolsToggleStartEvent
 */
export var GrowToolsToggleStart = function (_a) {
    var origin = _a.origin, type = _a.type, enabled = _a.enabled;
    return ({
        name: "GrowTools Toggle Start",
        parameters: {
            cdf_entity: "GrowTools",
            cdf_action: "Toggle",
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            enabled: enabled !== undefined && enabled !== null ? enabled.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GrowToolsToggleOffConfirmEvent
 */
export var GrowToolsToggleOffConfirm = function (_a) {
    var origin = _a.origin, type = _a.type;
    return ({
        name: "GrowTools Toggle OffConfirm",
        parameters: {
            cdf_entity: "GrowTools",
            cdf_action: "Toggle",
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GrowToolsToggleCancelEvent
 */
export var GrowToolsToggleCancel = function (_a) {
    var origin = _a.origin, type = _a.type;
    return ({
        name: "GrowTools Toggle Cancel",
        parameters: {
            cdf_entity: "GrowTools",
            cdf_action: "Toggle",
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GrowToolsToggleSuccessEvent
 */
export var GrowToolsToggleSuccess = function (_a) {
    var origin = _a.origin, type = _a.type;
    return ({
        name: "GrowTools Toggle Success",
        parameters: {
            cdf_entity: "GrowTools",
            cdf_action: "Toggle",
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
/**
 * @see GrowToolsToggleErrorEvent
 */
export var GrowToolsToggleError = function (_a) {
    var origin = _a.origin, type = _a.type;
    return ({
        name: "GrowTools Toggle Error",
        parameters: {
            cdf_entity: "GrowTools",
            cdf_action: "Toggle",
            origin: origin !== undefined && origin !== null ? origin.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined,
            type: type !== undefined && type !== null ? type.toString().substring(0, CUSTOMER_DATA_FRAMEWORK.LIMITS.STRING_PARAM_MAX_LENGTH) : undefined
        }
    });
};
